export default __webpack_public_path__ + "static/media/rectangleTall.8fe8abc4.png";